import React, {useState, useEffect} from "react";
import Header from 'components/Headers/Header';
import {  Card,CardHeader,CardBody,CardFooter,Media,Table,Container,Row,Button,} from 'reactstrap'
import ImageMapper from 'react-img-mapper'
import hotel0floormapImage from './files/hotel0floormap.png'
import hotel1stfloormapImage from './files/hotel1stfloormap.png'
import hotel2ndfloormapImage from './files/hotel2ndfloormap.png'
import hotel3rdfloormapImage from './files/hotel3rdfloormap.png'
import bellavista0floormapImage from './files/bellavista0floormap.png'
import { floorAll } from "network/ApiAccomodation";
import RoomModal from "./RoomModal";
import CheckOutModal from './CheckOutModal';
import CheckInModal from './CheckInModal';

const Accommodation =(props)=>{
    const [floorMap, setFloorMap] = useState(null);
    const [MAP, setMAP] = useState();
    const [modal, setModal] = useState(false);
    const [selectedRoom, setSelectedRoom] = useState();
    
    const [inModal, setInModal] = useState(false);
    const [outModal, setOutModal] = useState(false);

    const [URL, setURL] = useState(null);
    const [floorSelect, setFloorSelect] = useState(null);

    const inToggle = () => setInModal(!inModal);
    const outToggle = () => setOutModal(!outModal);
    const toggle = () => setModal(!modal);

    const [mapReload, setMapReload] = useState('a');

    const role = JSON.parse(localStorage.getItem("user")).role;

    useEffect(() => {
      if(URL){
        getFloorData();
      }
    }, [mapReload,floorSelect]);


    const getFloorData = async()=>{
      const resp = await floorAll(floorSelect)
      if(resp.data.success){
        setMAP({
          name: 'my-map',
          // GET JSON FROM BELOW URL AS AN EXAMPLE
          areas: resp.data.floor,
        });
        setFloorMap(resp.data.floor)
      }
    }

    //const user = JSON.parse(localStorage.getItem("user"));~
    //const URL = hotel2ndfloormapImage;

    const openModal = (area)=>{
      toggle()
      return <RoomModal area={area} toggle={toggle}/>
    }

    const changeFloor = (floorButton)=>{
      switch (floorButton) {
        case 'hotel-floor-0':
          setURL(hotel0floormapImage)
          break;
          case 'hotel-floor-1':
          setURL(hotel1stfloormapImage)
          break;
          case 'hotel-floor-2':
          setURL(hotel2ndfloormapImage)
          break;
          case 'hotel-floor-3':
          setURL(hotel3rdfloormapImage)
          break;
          case 'bella-vista-floor-0':
          setURL(bellavista0floormapImage)
          break;
      }
      setFloorSelect(floorButton)
    }
    
  
    return(<>
        {role == 'admin' && <Header />}
        {/* Page content */}
        <Container className="mt--2" fluid>
        
          <Card className="shadow">
            <CardHeader className="border-0">
              <Row>
                <Button onClick={()=>changeFloor('hotel-floor-0')} >Hotel Floor 0</Button>
                <Button onClick={()=>changeFloor('hotel-floor-1')} >Hotel Floor 1</Button>
                <Button onClick={()=>changeFloor('hotel-floor-2')} >Hotel Floor 2</Button>
                <Button onClick={()=>changeFloor('hotel-floor-3')} >Hotel Floor 3</Button>
                <Button onClick={()=>changeFloor('bella-vista-floor-0')}>Bella Vista</Button>
              </Row>
            
            </CardHeader>
            <CardBody>
            </CardBody>
              <Row className="justify-content-center" style={{overflow:'auto'}}> 
                {floorMap &&
                  <ImageMapper 
                      src={URL} 
                      map={MAP} 
                      onClick={(area,index,e)=>{
                        console.log(area)
                        setSelectedRoom(area)
                        toggle()
                      }}
                      
                  />
                }
              </Row>
          </Card>
          {modal && <RoomModal area={selectedRoom} toggle={toggle} modal={modal} inToggle={inToggle} outToggle={outToggle} mapReload={setMapReload} />}
          {inModal && <CheckInModal room={selectedRoom._id} inToggle={inToggle} inModal={inModal} mapReload={setMapReload} />}
          {outModal && <CheckOutModal room={selectedRoom._id} roomInfo={selectedRoom} outToggle={outToggle} outModal={outModal} mapReload={setMapReload} />}
        </Container>
    </>)
}

export default Accommodation;